import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [utente, setUtente] = useState(null);
  const [loading, setLoading] = useState(true);

  // Se il server rifiuta il token (utente disattivato, eliminato o token scaduto)
  // si esce subito, tranne che sul login stesso dove il 401 è "credenziali errate".
  useEffect(() => {
    const id = axios.interceptors.response.use(
      r => r,
      err => {
        const url = err.config?.url || '';
        if (err.response?.status === 401 && !url.includes('/api/auth/login')) {
          localStorage.removeItem('token');
          delete axios.defaults.headers.common['Authorization'];
          setUtente(null);
        }
        return Promise.reject(err);
      }
    );
    return () => axios.interceptors.response.eject(id);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get('/api/auth/me')
        .then(r => setUtente(r.data))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  function login(token, datiUtente) {
    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUtente(datiUtente);
  }

  function logout() {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['Authorization'];
    setUtente(null);
  }

  return (
    <AuthContext.Provider value={{ utente, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
